import { ADSyncerSpecifics, ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class SetADIntegratorValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;
  public canRunForMultipleItems = false;
  public canRunOnMultipleCompanies = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    const specifics = record.specifics as ADSyncerSpecifics;

    if (!ProtectedEntitiesHelper.acceptsAdIntegration(record) || !specifics.isManaged) {
      return false;
    }

    const isWindows = specifics.operatingSystem === Constants.ProtectedEntities.OS.PROTECTED_ENTITY_OS_WIN;
    const isBest = specifics.appId === Constants.Endpoints.APP_IDS.APPID_UNIFIED_CLIENT;
    const isNotAlreadyAD = specifics.isAdSyncer === undefined || specifics.isAdSyncer === false;
    const isJoined =
      specifics.guid !== undefined ||
      specifics.ssid !== undefined ||
      (specifics.domainSid !== undefined && specifics.samAccountName !== undefined);
    const isOnline = specifics.isOnline !== null && specifics.isOnline === true;

    return isWindows && isBest && isNotAlreadyAD && isJoined && isOnline;
  }
}
